<template>
  <div>
    <o-base-justify-text v-if="getTexto('contrato.firmaDiferida', reserva.codigoPromocion)">
      <span v-html="getTexto('contrato.firmaDiferida', reserva.codigoPromocion)"></span>
    </o-base-justify-text>
    <v-layout row justify-center>
      <v-flex xs12 lg6>
        <v-data-table
          :headers="headers"
          :items="filteredItems"
          hide-actions
          class="mb-2"
        >
          <template #items="props">
            <tr :class="{pointer: $vuetify.breakpoint.smAndDown}">
              <td>
                <v-layout row>
                  {{ props.item.nombre }}
                </v-layout>
              </td>
              <td class="text-xs-center">{{ props.item.firmado }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-btn 
        v-if="esAdministrador || esComercial"
        color="primary"
        @click="enviarRecordatorio"
        :disabled="waitingForLoad"
        :loading="waitingForLoad"
      >
        {{$t('reservas.contrato.enviarRecordatorio')}}
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import rulesMixin from '@/mixins/rules.js'
export default {
  mixins: [rulesMixin],
  props: {
    contratoId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      waitingForLoad: false
    }
  },
  computed: {
    ...mapGetters({
      reserva: 'reservas/_id/getActual'
    }),
    headers () {
      return [
        {
          text: this.$t('general.misc.nombre'),
          value: 'nombre',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('reservas.contrato.contratoFirmadoHeader'),
          value: 'firmado',
          align: 'center',
          sortable: true
        }
      ]
    },
    filteredItems () {
      return this.reserva.contrato.firmantes.map(f => {
        return {
          id: f.id,
          nombre: f.nombreApellidos,
          firmado: f.estado.codigo === 10 ? this.$t('reservas.formularioFisico.si') : this.$t('reservas.formularioFisico.no')
        }
      })
    }
  },
  methods: {
    ...mapActions({
      loadContratosFirmantes: 'contratosFirmantes/loadAll',
      mandarCorreoRecordatorio: 'contratos/enviarRecordatorio',
      addAlert: 'alerts/add'
    }),
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    async enviarRecordatorio () {
      try {
        this.waitingForLoad = true
        await this.mandarCorreoRecordatorio(this.reserva.contrato.id)
        this.addAlert({texto: this.$t('reservas.contrato.emailEnviado'), color: 'success'})
      } catch (error) {
        console.log(error)
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      } finally {
        this.waitingForLoad = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservas/contratos/ContratoMostrarFirmantesEmail.vue